import { StoreMap } from '../stores/StoreMap';
import type { StoreItem } from '../stores/types';

interface HomeLocationConfig {
    provider: string;
    scriptUrl: string;
    globalPinUrl: string;
    stores: StoreItem[];
}

/**
 * 메인 페이지 Location 섹션의 지도(카카오/네이버) 마운트.
 * 섹션이 출력한 #home-location-data(JSON) + #home-location-map(컨테이너)를 읽어
 * 기존 StoreMap(단일 매장 마커) 으로 렌더한다. 요소·설정이 없으면 조용히 종료.
 */
export const HomeLocationController = {
    init(): void {
        const configEl = document.getElementById('home-location-data');
        const mapNode = document.getElementById('home-location-map');
        if (!configEl || !mapNode) return;

        const state = mapNode.dataset.homeLocationState;
        if (state === 'loading' || state === 'mounted') return;

        let config: HomeLocationConfig;
        try {
            config = JSON.parse(configEl.textContent || '{}') as HomeLocationConfig;
        } catch {
            return;
        }

        const stores: StoreItem[] = Array.isArray(config.stores) ? config.stores : [];
        if (!config.scriptUrl || stores.length === 0) return;

        // 마커 클릭 → 해당 매장의 map_url(네이버지도 바로가기)을 새 탭으로 (CTA 버튼과 동일 동작).
        const openMapUrl = (id: string): void => {
            const store = stores.find((s) => String(s.id) === id);
            const url = store && store.map_url ? store.map_url : '';
            if (url) window.open(url, '_blank', 'noopener');
        };

        const storeMap = new StoreMap(
            config.provider || 'naver',
            stores,
            config.globalPinUrl || '',
            openMapUrl,
        );
        mapNode.dataset.homeLocationState = 'loading';
        storeMap
            .mount(config.scriptUrl, mapNode)
            .then(() => {
                mapNode.dataset.homeLocationState = 'mounted';
            })
            .catch(() => {
                mapNode.dataset.homeLocationState = 'error';
                mapNode.innerHTML = '<div class="map-status no-body-md --700">지도를 불러오지 못했습니다.</div>';
            });
    },
};
